// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_0d-nm","breadcrumbs":"index_breadcrumbs_04T86"};